import Vue from 'vue';
import { setupHttpInterceptor } from './axios_intercept';
import { initErrorHandler } from './error_handler';

export function initHttpInterceptors(vue: typeof Vue) {
  // Инициализируем обработчик ошибок с Vue
  initErrorHandler(vue.prototype);
  
  // Настраиваем интерцепторы
  setupHttpInterceptor();
}